import './OptionTile.scss'

import cls from 'classnames'
import type { ButtonHTMLAttributes, MouseEventHandler, ReactNode } from 'react'
import Ripple from '../../Animations/Ripple/Ripple'

type OptionProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'onClick'> & {
	readonly active?: boolean
	readonly animate?: boolean
	readonly children: string | ReactNode
	readonly className?: string
	readonly onClick?: MouseEventHandler<HTMLButtonElement>
}

export const OptionTile = ({
	active = false,
	animate = true,
	children,
	className,
	onClick,
	...p
}: OptionProps) => {
	return (
		<button
			{...p}
			type="button"
			onClick={onClick}
			className={cls(
				'optiontile relative flex-center h-16 overflow-hidden rounded-2xl',
				{ 'border-solid border-2 border-teal-2dk bg-teal-3lt': active },
				className,
			)}
		>
			{typeof children === 'string' ?
				<p className="text-gray-950 font-semibold text-base m-0 p-0">{children}</p>
			:	children}
			{animate && <Ripple />}
		</button>
	)
}
